import { AbTestMedium } from "./AbTestMedium";
import { AbTestSmall } from "./AbTestSmall";
import { ActivityMedium } from "./ActivityMedium";
import { ActivitySmall } from "./ActivitySmall";
import { ActivitySolidMedium } from "./ActivitySolidMedium";
import { ActivitySolidSmall } from "./ActivitySolidSmall";
import { AlarmClockMedium } from "./AlarmClockMedium";
import { AlarmClockSmall } from "./AlarmClockSmall";
import { AlbumMedium } from "./AlbumMedium";
import { AlbumSmall } from "./AlbumSmall";
import { AlignCenterMedium } from "./AlignCenterMedium";
import { AlignCenterSmall } from "./AlignCenterSmall";
import { AlignLeftMedium } from "./AlignLeftMedium";
import { AlignLeftSmall } from "./AlignLeftSmall";
import { AlignRightMedium } from "./AlignRightMedium";
import { AlignRightSmall } from "./AlignRightSmall";
import { AndroidSolidMedium } from "./AndroidSolidMedium";
import { AndroidSolidSmall } from "./AndroidSolidSmall";
import { AppMedium } from "./AppMedium";
import { AppSmall } from "./AppSmall";
import { AppSolidMedium } from "./AppSolidMedium";
import { AppSolidSmall } from "./AppSolidSmall";
import { AppleSolidMedium } from "./AppleSolidMedium";
import { AppleSolidSmall } from "./AppleSolidSmall";
import { ArchiveMedium } from "./ArchiveMedium";
import { ArchiveSmall } from "./ArchiveSmall";
import { ArrowDownLeftMedium } from "./ArrowDownLeftMedium";
import { ArrowDownLeftSmall } from "./ArrowDownLeftSmall";
import { ArrowDownMedium } from "./ArrowDownMedium";
import { ArrowDownRightMedium } from "./ArrowDownRightMedium";
import { ArrowDownRightSmall } from "./ArrowDownRightSmall";
import { ArrowDownSmall } from "./ArrowDownSmall";
import { ArrowDownUpMedium } from "./ArrowDownUpMedium";
import { ArrowDownUpSmall } from "./ArrowDownUpSmall";
import { ArrowLeftMedium } from "./ArrowLeftMedium";
import { ArrowLeftSmall } from "./ArrowLeftSmall";
import { ArrowRightLeftMedium } from "./ArrowRightLeftMedium";
import { ArrowRightLeftSmall } from "./ArrowRightLeftSmall";
import { ArrowRightMedium } from "./ArrowRightMedium";
import { ArrowRightSmall } from "./ArrowRightSmall";
import { ArrowUpDownMedium } from "./ArrowUpDownMedium";
import { ArrowUpDownSmall } from "./ArrowUpDownSmall";
import { ArrowUpLeftMedium } from "./ArrowUpLeftMedium";
import { ArrowUpLeftSmall } from "./ArrowUpLeftSmall";
import { ArrowUpMedium } from "./ArrowUpMedium";
import { ArrowUpRightMedium } from "./ArrowUpRightMedium";
import { ArrowUpRightSmall } from "./ArrowUpRightSmall";
import { ArrowUpSmall } from "./ArrowUpSmall";
import { AsteriskMedium } from "./AsteriskMedium";
import { AsteriskSmall } from "./AsteriskSmall";
import { AtSignMedium } from "./AtSignMedium";
import { AtSignSmall } from "./AtSignSmall";
import { BankMedium } from "./BankMedium";
import { BankSmall } from "./BankSmall";
import { BanknoteMedium } from "./BanknoteMedium";
import { BanknoteSmall } from "./BanknoteSmall";
import { BanknoteSolidMedium } from "./BanknoteSolidMedium";
import { BanknoteSolidSmall } from "./BanknoteSolidSmall";
import { BellMedium } from "./BellMedium";
import { BellSmall } from "./BellSmall";
import { BitcoinMedium } from "./BitcoinMedium";
import { BitcoinSmall } from "./BitcoinSmall";
import { BoltMedium } from "./BoltMedium";
import { BoltSmall } from "./BoltSmall";
import { BookClosedMedium } from "./BookClosedMedium";
import { BookClosedSmall } from "./BookClosedSmall";
import { BookOpenMedium } from "./BookOpenMedium";
import { BookOpenSmall } from "./BookOpenSmall";
import { BookOpenSolidMedium } from "./BookOpenSolidMedium";
import { BookOpenSolidSmall } from "./BookOpenSolidSmall";
import { BookmarkMedium } from "./BookmarkMedium";
import { BookmarkSmall } from "./BookmarkSmall";
import { BoxMedium } from "./BoxMedium";
import { BoxSelectMedium } from "./BoxSelectMedium";
import { BoxSelectSmall } from "./BoxSelectSmall";
import { BoxSmall } from "./BoxSmall";
import { BrushMedium } from "./BrushMedium";
import { BrushSmall } from "./BrushSmall";
import { BuildingMedium } from "./BuildingMedium";
import { BuildingSmall } from "./BuildingSmall";
import { BusMedium } from "./BusMedium";
import { BusSmall } from "./BusSmall";
import { CalculcatorMedium } from "./CalculcatorMedium";
import { CalculcatorSmall } from "./CalculcatorSmall";
import { CalendarMedium } from "./CalendarMedium";
import { CalendarSmall } from "./CalendarSmall";
import { CameraMedium } from "./CameraMedium";
import { CameraSmall } from "./CameraSmall";
import { CarMedium } from "./CarMedium";
import { CarSmall } from "./CarSmall";
import { ChartAreaMedium } from "./ChartAreaMedium";
import { ChartAreaSmall } from "./ChartAreaSmall";
import { ChartColumnMedium } from "./ChartColumnMedium";
import { ChartColumnSmall } from "./ChartColumnSmall";
import { ChartColumnSolidMedium } from "./ChartColumnSolidMedium";
import { ChartColumnSolidSmall } from "./ChartColumnSolidSmall";
import { ChartComboMedium } from "./ChartComboMedium";
import { ChartComboSmall } from "./ChartComboSmall";
import { ChartHandleMedium } from "./ChartHandleMedium";
import { ChartHandleSmall } from "./ChartHandleSmall";
import { ChartLineMedium } from "./ChartLineMedium";
import { ChartLineSmall } from "./ChartLineSmall";
import { ChartLineSolidMedium } from "./ChartLineSolidMedium";
import { ChartLineSolidSmall } from "./ChartLineSolidSmall";
import { ChartPieMedium } from "./ChartPieMedium";
import { ChartPieSmall } from "./ChartPieSmall";
import { ChartPieSolidMedium } from "./ChartPieSolidMedium";
import { ChartPieSolidSmall } from "./ChartPieSolidSmall";
import { ChartScatterMedium } from "./ChartScatterMedium";
import { ChartScatterSmall } from "./ChartScatterSmall";
import { CheckCircleMedium } from "./CheckCircleMedium";
import { CheckCircleSmall } from "./CheckCircleSmall";
import { CheckCircleSolidMedium } from "./CheckCircleSolidMedium";
import { CheckCircleSolidSmall } from "./CheckCircleSolidSmall";
import { CheckMedium } from "./CheckMedium";
import { CheckSmall } from "./CheckSmall";
import { CheckSolidMedium } from "./CheckSolidMedium";
import { CheckSolidSmall } from "./CheckSolidSmall";
import { ChevronDownMedium } from "./ChevronDownMedium";
import { ChevronDownSmall } from "./ChevronDownSmall";
import { ChevronFirstMedium } from "./ChevronFirstMedium";
import { ChevronFirstSmall } from "./ChevronFirstSmall";
import { ChevronLastMedium } from "./ChevronLastMedium";
import { ChevronLastSmall } from "./ChevronLastSmall";
import { ChevronLeftMedium } from "./ChevronLeftMedium";
import { ChevronLeftSmall } from "./ChevronLeftSmall";
import { ChevronRightMedium } from "./ChevronRightMedium";
import { ChevronRightSmall } from "./ChevronRightSmall";
import { ChevronUpMedium } from "./ChevronUpMedium";
import { ChevronUpSmall } from "./ChevronUpSmall";
import { ChevronsDownMedium } from "./ChevronsDownMedium";
import { ChevronsDownSmall } from "./ChevronsDownSmall";
import { ChevronsDownUpMedium } from "./ChevronsDownUpMedium";
import { ChevronsDownUpSmall } from "./ChevronsDownUpSmall";
import { ChevronsLeftMedium } from "./ChevronsLeftMedium";
import { ChevronsLeftSmall } from "./ChevronsLeftSmall";
import { ChevronsRightMedium } from "./ChevronsRightMedium";
import { ChevronsRightSmall } from "./ChevronsRightSmall";
import { ChevronsUpDownMedium } from "./ChevronsUpDownMedium";
import { ChevronsUpDownSmall } from "./ChevronsUpDownSmall";
import { ChevronsUpMedium } from "./ChevronsUpMedium";
import { ChevronsUpSmall } from "./ChevronsUpSmall";
import { ClipboardCheckMedium } from "./ClipboardCheckMedium";
import { ClipboardCheckSmall } from "./ClipboardCheckSmall";
import { ClipboardListMedium } from "./ClipboardListMedium";
import { ClipboardListSmall } from "./ClipboardListSmall";
import { ClipboardMedium } from "./ClipboardMedium";
import { ClipboardSmall } from "./ClipboardSmall";
import { ClockMedium } from "./ClockMedium";
import { ClockSmall } from "./ClockSmall";
import { ClockSolidMedium } from "./ClockSolidMedium";
import { ClockSolidSmall } from "./ClockSolidSmall";
import { CloseCircleMedium } from "./CloseCircleMedium";
import { CloseCircleSmall } from "./CloseCircleSmall";
import { CloseCircleSolidMedium } from "./CloseCircleSolidMedium";
import { CloseCircleSolidSmall } from "./CloseCircleSolidSmall";
import { CloseMedium } from "./CloseMedium";
import { CloseSmall } from "./CloseSmall";
import { CloseSolidMedium } from "./CloseSolidMedium";
import { CloseSolidSmall } from "./CloseSolidSmall";
import { CloudMedium } from "./CloudMedium";
import { CloudSmall } from "./CloudSmall";
import { CodeBranchMedium } from "./CodeBranchMedium";
import { CodeBranchPlusMedium } from "./CodeBranchPlusMedium";
import { CodeBranchPlusSmall } from "./CodeBranchPlusSmall";
import { CodeBranchSmall } from "./CodeBranchSmall";
import { CodeCloseMedium } from "./CodeCloseMedium";
import { CodeCloseSmall } from "./CodeCloseSmall";
import { CodeCloseSolidMedium } from "./CodeCloseSolidMedium";
import { CodeCloseSolidSmall } from "./CodeCloseSolidSmall";
import { CodeCommitMedium } from "./CodeCommitMedium";
import { CodeCommitSmall } from "./CodeCommitSmall";
import { CodeForkMedium } from "./CodeForkMedium";
import { CodeForkSmall } from "./CodeForkSmall";
import { CodeMergeMedium } from "./CodeMergeMedium";
import { CodeMergeSmall } from "./CodeMergeSmall";
import { CodeMergeSolidMedium } from "./CodeMergeSolidMedium";
import { CodeMergeSolidSmall } from "./CodeMergeSolidSmall";
import { CodeOpenMedium } from "./CodeOpenMedium";
import { CodeOpenSmall } from "./CodeOpenSmall";
import { CodePullRequestMedium } from "./CodePullRequestMedium";
import { CodePullRequestSmall } from "./CodePullRequestSmall";
import { CoinsMedium } from "./CoinsMedium";
import { CoinsSmall } from "./CoinsSmall";
import { CompressMedium } from "./CompressMedium";
import { CompressSmall } from "./CompressSmall";
import { ConditionMedium } from "./ConditionMedium";
import { ConditionSmall } from "./ConditionSmall";
import { ContactMedium } from "./ContactMedium";
import { ContactSmall } from "./ContactSmall";
import { ContainCaseSensitiveMedium } from "./ContainCaseSensitiveMedium";
import { ContainCaseSensitiveSmall } from "./ContainCaseSensitiveSmall";
import { ContainMedium } from "./ContainMedium";
import { ContainSmall } from "./ContainSmall";
import { CopyMedium } from "./CopyMedium";
import { CopySmall } from "./CopySmall";
import { CornerDownLeftMedium } from "./CornerDownLeftMedium";
import { CornerDownLeftSmall } from "./CornerDownLeftSmall";
import { CornerDownRightMedium } from "./CornerDownRightMedium";
import { CornerDownRightSmall } from "./CornerDownRightSmall";
import { CornerLeftDownMedium } from "./CornerLeftDownMedium";
import { CornerLeftDownSmall } from "./CornerLeftDownSmall";
import { CornerLeftUpMedium } from "./CornerLeftUpMedium";
import { CornerLeftUpSmall } from "./CornerLeftUpSmall";
import { CornerRightDownMedium } from "./CornerRightDownMedium";
import { CornerRightDownSmall } from "./CornerRightDownSmall";
import { CornerRightUpMedium } from "./CornerRightUpMedium";
import { CornerRightUpSmall } from "./CornerRightUpSmall";
import { CornerUpLeftMedium } from "./CornerUpLeftMedium";
import { CornerUpLeftSmall } from "./CornerUpLeftSmall";
import { CornerUpRightMedium } from "./CornerUpRightMedium";
import { CornerUpRightSmall } from "./CornerUpRightSmall";
import { CreditCardMedium } from "./CreditCardMedium";
import { CreditCardSmall } from "./CreditCardSmall";
import { CrosshairMedium } from "./CrosshairMedium";
import { CrosshairSmall } from "./CrosshairSmall";
import { CrownMedium } from "./CrownMedium";
import { CrownSmall } from "./CrownSmall";
import { CubeMedium } from "./CubeMedium";
import { CubeSmall } from "./CubeSmall";
import { CurrencyMedium } from "./CurrencyMedium";
import { CurrencySmall } from "./CurrencySmall";
import { DashboardMedium } from "./DashboardMedium";
import { DashboardSmall } from "./DashboardSmall";
import { DatabaseMedium } from "./DatabaseMedium";
import { DatabaseSmall } from "./DatabaseSmall";
import { DesktopMedium } from "./DesktopMedium";
import { DesktopSmall } from "./DesktopSmall";
import { DiscordSolidMedium } from "./DiscordSolidMedium";
import { DiscordSolidSmall } from "./DiscordSolidSmall";
import { DivideMedium } from "./DivideMedium";
import { DivideSmall } from "./DivideSmall";
import { DollarMedium } from "./DollarMedium";
import { DollarSmall } from "./DollarSmall";
import { DownloadCloudMedium } from "./DownloadCloudMedium";
import { DownloadCloudSmall } from "./DownloadCloudSmall";
import { DownloadMedium } from "./DownloadMedium";
import { DownloadSmall } from "./DownloadSmall";
import { EditMedium } from "./EditMedium";
import { EditSmall } from "./EditSmall";
import { EmptyMedium } from "./EmptyMedium";
import { EmptySmall } from "./EmptySmall";
import { EnvelopeMedium } from "./EnvelopeMedium";
import { EnvelopeSmall } from "./EnvelopeSmall";
import { EqualMedium } from "./EqualMedium";
import { EqualSlashMedium } from "./EqualSlashMedium";
import { EqualSlashSmall } from "./EqualSlashSmall";
import { EqualSmall } from "./EqualSmall";
import { EuroMedium } from "./EuroMedium";
import { EuroSmall } from "./EuroSmall";
import { ExclamationMedium } from "./ExclamationMedium";
import { ExclamationSmall } from "./ExclamationSmall";
import { ExclamationSolidMedium } from "./ExclamationSolidMedium";
import { ExclamationSolidSmall } from "./ExclamationSolidSmall";
import { ExclamationTriangleMedium } from "./ExclamationTriangleMedium";
import { ExclamationTriangleSmall } from "./ExclamationTriangleSmall";
import { ExclamationTriangleSolidMedium } from "./ExclamationTriangleSolidMedium";
import { ExclamationTriangleSolidSmall } from "./ExclamationTriangleSolidSmall";
import { ExpandMedium } from "./ExpandMedium";
import { ExpandSmall } from "./ExpandSmall";
import { ExternalLinkMedium } from "./ExternalLinkMedium";
import { ExternalLinkSmall } from "./ExternalLinkSmall";
import { EyeMedium } from "./EyeMedium";
import { EyeSlashMedium } from "./EyeSlashMedium";
import { EyeSlashSmall } from "./EyeSlashSmall";
import { EyeSmall } from "./EyeSmall";
import { FileCheckMedium } from "./FileCheckMedium";
import { FileCheckSmall } from "./FileCheckSmall";
import { FileCodeMedium } from "./FileCodeMedium";
import { FileCodeSmall } from "./FileCodeSmall";
import { FileExportMedium } from "./FileExportMedium";
import { FileExportSmall } from "./FileExportSmall";
import { FileImportMedium } from "./FileImportMedium";
import { FileImportSmall } from "./FileImportSmall";
import { FileMedium } from "./FileMedium";
import { FileMinusMedium } from "./FileMinusMedium";
import { FileMinusSmall } from "./FileMinusSmall";
import { FilePlusMedium } from "./FilePlusMedium";
import { FilePlusSmall } from "./FilePlusSmall";
import { FileSmall } from "./FileSmall";
import { FileSpreadsheetMedium } from "./FileSpreadsheetMedium";
import { FileSpreadsheetSmall } from "./FileSpreadsheetSmall";
import { FileTextMedium } from "./FileTextMedium";
import { FileTextSmall } from "./FileTextSmall";
import { FilesMedium } from "./FilesMedium";
import { FilesSmall } from "./FilesSmall";
import { FilterMedium } from "./FilterMedium";
import { FilterSmall } from "./FilterSmall";
import { FlagMedium } from "./FlagMedium";
import { FlagSmall } from "./FlagSmall";
import { FolderMedium } from "./FolderMedium";
import { FolderOpenMedium } from "./FolderOpenMedium";
import { FolderOpenSmall } from "./FolderOpenSmall";
import { FolderSmall } from "./FolderSmall";
import { FontCaseMedium } from "./FontCaseMedium";
import { FontCaseSmall } from "./FontCaseSmall";
import { FontMedium } from "./FontMedium";
import { FontSmall } from "./FontSmall";
import { FormInputMedium } from "./FormInputMedium";
import { FormInputSmall } from "./FormInputSmall";
import { ForwardMedium } from "./ForwardMedium";
import { ForwardSmall } from "./ForwardSmall";
import { GaugeMedium } from "./GaugeMedium";
import { GaugeSmall } from "./GaugeSmall";
import { GemMedium } from "./GemMedium";
import { GemSmall } from "./GemSmall";
import { GiftMedium } from "./GiftMedium";
import { GiftSmall } from "./GiftSmall";
import { GithubMedium } from "./GithubMedium";
import { GithubSmall } from "./GithubSmall";
import { GlassesMedium } from "./GlassesMedium";
import { GlassesSmall } from "./GlassesSmall";
import { GlobeMedium } from "./GlobeMedium";
import { GlobeSmall } from "./GlobeSmall";
import { GreaterThanEqualMedium } from "./GreaterThanEqualMedium";
import { GreaterThanEqualSmall } from "./GreaterThanEqualSmall";
import { GreaterThanMedium } from "./GreaterThanMedium";
import { GreaterThanSmall } from "./GreaterThanSmall";
import { GridMedium } from "./GridMedium";
import { GridSmall } from "./GridSmall";
import { GripHorizontalMedium } from "./GripHorizontalMedium";
import { GripHorizontalSmall } from "./GripHorizontalSmall";
import { GripVerticalMedium } from "./GripVerticalMedium";
import { GripVerticalSmall } from "./GripVerticalSmall";
import { HammerMedium } from "./HammerMedium";
import { HammerSmall } from "./HammerSmall";
import { HashMedium } from "./HashMedium";
import { HashSmall } from "./HashSmall";
import { HeartMedium } from "./HeartMedium";
import { HeartSmall } from "./HeartSmall";
import { HeartSolidMedium } from "./HeartSolidMedium";
import { HeartSolidSmall } from "./HeartSolidSmall";
import { HighlighterMedium } from "./HighlighterMedium";
import { HighlighterSmall } from "./HighlighterSmall";
import { HomeMedium } from "./HomeMedium";
import { HomeSmall } from "./HomeSmall";
import { HomeSolidMedium } from "./HomeSolidMedium";
import { HomeSolidSmall } from "./HomeSolidSmall";
import { ICursorMedium } from "./ICursorMedium";
import { ICursorSmall } from "./ICursorSmall";
import { ImageMedium } from "./ImageMedium";
import { ImageSmall } from "./ImageSmall";
import { InBetweenMedium } from "./InBetweenMedium";
import { InBetweenSmall } from "./InBetweenSmall";
import { InfoCircleMedium } from "./InfoCircleMedium";
import { InfoCircleSmall } from "./InfoCircleSmall";
import { InfoCircleSolidMedium } from "./InfoCircleSolidMedium";
import { InfoCircleSolidSmall } from "./InfoCircleSolidSmall";
import { InfoMedium } from "./InfoMedium";
import { InfoSmall } from "./InfoSmall";
import { InfoSolidMedium } from "./InfoSolidMedium";
import { InfoSolidSmall } from "./InfoSolidSmall";
import { IntegrationsMedium } from "./IntegrationsMedium";
import { IntegrationsSmall } from "./IntegrationsSmall";
import { IntegrationsSolidMedium } from "./IntegrationsSolidMedium";
import { IntegrationsSolidSmall } from "./IntegrationsSolidSmall";
import { KeyMedium } from "./KeyMedium";
import { KeySmall } from "./KeySmall";
import { LaptopMedium } from "./LaptopMedium";
import { LaptopSmall } from "./LaptopSmall";
import { LayersMedium } from "./LayersMedium";
import { LayersSmall } from "./LayersSmall";
import { LessThanEqualMedium } from "./LessThanEqualMedium";
import { LessThanEqualSmall } from "./LessThanEqualSmall";
import { LessThanMedium } from "./LessThanMedium";
import { LessThanSmall } from "./LessThanSmall";
import { LibraryMedium } from "./LibraryMedium";
import { LibrarySmall } from "./LibrarySmall";
import { LightbulbMedium } from "./LightbulbMedium";
import { LightbulbSmall } from "./LightbulbSmall";
import { LinkMedium } from "./LinkMedium";
import { LinkSlashMedium } from "./LinkSlashMedium";
import { LinkSlashSmall } from "./LinkSlashSmall";
import { LinkSmall } from "./LinkSmall";
import { ListMedium } from "./ListMedium";
import { ListSmall } from "./ListSmall";
import { ListSolidMedium } from "./ListSolidMedium";
import { ListSolidSmall } from "./ListSolidSmall";
import { LoaderMedium } from "./LoaderMedium";
import { LoaderSmall } from "./LoaderSmall";
import { LocationFixedMedium } from "./LocationFixedMedium";
import { LocationFixedSmall } from "./LocationFixedSmall";
import { LocationMedium } from "./LocationMedium";
import { LocationSmall } from "./LocationSmall";
import { LockMedium } from "./LockMedium";
import { LockSmall } from "./LockSmall";
import { LockSolidMedium } from "./LockSolidMedium";
import { LockSolidSmall } from "./LockSolidSmall";
import { LogInMedium } from "./LogInMedium";
import { LogInSmall } from "./LogInSmall";
import { LogOutMedium } from "./LogOutMedium";
import { LogOutSmall } from "./LogOutSmall";
import { LogOutSolidMedium } from "./LogOutSolidMedium";
import { LogOutSolidSmall } from "./LogOutSolidSmall";
import { MapMedium } from "./MapMedium";
import { MapPinMedium } from "./MapPinMedium";
import { MapPinSmall } from "./MapPinSmall";
import { MapSmall } from "./MapSmall";
import { MaximiseMedium } from "./MaximiseMedium";
import { MaximiseSmall } from "./MaximiseSmall";
import { MegaphoneMedium } from "./MegaphoneMedium";
import { MegaphoneSmall } from "./MegaphoneSmall";
import { MenuMedium } from "./MenuMedium";
import { MenuSmall } from "./MenuSmall";
import { MergeMedium } from "./MergeMedium";
import { MergeSmall } from "./MergeSmall";
import { MessageMedium } from "./MessageMedium";
import { MessageSmall } from "./MessageSmall";
import { MessageSolidMedium } from "./MessageSolidMedium";
import { MessageSolidSmall } from "./MessageSolidSmall";
import { MicrochipMedium } from "./MicrochipMedium";
import { MicrochipSmall } from "./MicrochipSmall";
import { MinimiseMedium } from "./MinimiseMedium";
import { MinimiseSmall } from "./MinimiseSmall";
import { MinusCircleMedium } from "./MinusCircleMedium";
import { MinusCircleSmall } from "./MinusCircleSmall";
import { MinusCircleSolidMedium } from "./MinusCircleSolidMedium";
import { MinusCircleSolidSmall } from "./MinusCircleSolidSmall";
import { MinusMedium } from "./MinusMedium";
import { MinusSmall } from "./MinusSmall";
import { MinusSolidMedium } from "./MinusSolidMedium";
import { MinusSolidSmall } from "./MinusSolidSmall";
import { MoreHorizontalMedium } from "./MoreHorizontalMedium";
import { MoreHorizontalSmall } from "./MoreHorizontalSmall";
import { MoreVerticalMedium } from "./MoreVerticalMedium";
import { MoreVerticalSmall } from "./MoreVerticalSmall";
import { MoveDiagonal1Medium } from "./MoveDiagonal1Medium";
import { MoveDiagonal1Small } from "./MoveDiagonal1Small";
import { MoveDiagonal2Medium } from "./MoveDiagonal2Medium";
import { MoveDiagonal2Small } from "./MoveDiagonal2Small";
import { MoveHorizontalMedium } from "./MoveHorizontalMedium";
import { MoveHorizontalSmall } from "./MoveHorizontalSmall";
import { MoveMedium } from "./MoveMedium";
import { MoveSmall } from "./MoveSmall";
import { MoveVerticalMedium } from "./MoveVerticalMedium";
import { MoveVerticalSmall } from "./MoveVerticalSmall";
import { MuteMedium } from "./MuteMedium";
import { MuteSmall } from "./MuteSmall";
import { NetworkWiredMedium } from "./NetworkWiredMedium";
import { NetworkWiredSmall } from "./NetworkWiredSmall";
import { NewsMedium } from "./NewsMedium";
import { NewsSmall } from "./NewsSmall";
import { NotContainCaseSensitiveMedium } from "./NotContainCaseSensitiveMedium";
import { NotContainCaseSensitiveSmall } from "./NotContainCaseSensitiveSmall";
import { NotContainMedium } from "./NotContainMedium";
import { NotContainSmall } from "./NotContainSmall";
import { NotEmptyMedium } from "./NotEmptyMedium";
import { NotEmptySmall } from "./NotEmptySmall";
import { NotOneOfMedium } from "./NotOneOfMedium";
import { NotOneOfSmall } from "./NotOneOfSmall";
import { OneOfMedium } from "./OneOfMedium";
import { OneOfSmall } from "./OneOfSmall";
import { PaletteMedium } from "./PaletteMedium";
import { PaletteSmall } from "./PaletteSmall";
import { PanelCloseMedium } from "./PanelCloseMedium";
import { PanelOpenMedium } from "./PanelOpenMedium";
import { PaperclipMedium } from "./PaperclipMedium";
import { PaperclipSmall } from "./PaperclipSmall";
import { PenMedium } from "./PenMedium";
import { PenSmall } from "./PenSmall";
import { PencilMedium } from "./PencilMedium";
import { PencilSmall } from "./PencilSmall";
import { PercentMedium } from "./PercentMedium";
import { PercentSmall } from "./PercentSmall";
import { PhoneMedium } from "./PhoneMedium";
import { PhoneSmall } from "./PhoneSmall";
import { PlayMedium } from "./PlayMedium";
import { PlaySmall } from "./PlaySmall";
import { PlaySolidMedium } from "./PlaySolidMedium";
import { PlaySolidSmall } from "./PlaySolidSmall";
import { PlugMedium } from "./PlugMedium";
import { PlugSmall } from "./PlugSmall";
import { PlusCircleMedium } from "./PlusCircleMedium";
import { PlusCircleSmall } from "./PlusCircleSmall";
import { PlusCircleSolidMedium } from "./PlusCircleSolidMedium";
import { PlusCircleSolidSmall } from "./PlusCircleSolidSmall";
import { PlusMedium } from "./PlusMedium";
import { PlusSmall } from "./PlusSmall";
import { PlusSolidMedium } from "./PlusSolidMedium";
import { PlusSolidSmall } from "./PlusSolidSmall";
import { PowerMedium } from "./PowerMedium";
import { PowerSmall } from "./PowerSmall";
import { QuestionCircleMedium } from "./QuestionCircleMedium";
import { QuestionCircleSmall } from "./QuestionCircleSmall";
import { QuestionCircleSolidMedium } from "./QuestionCircleSolidMedium";
import { QuestionCircleSolidSmall } from "./QuestionCircleSolidSmall";
import { QuestionMedium } from "./QuestionMedium";
import { QuestionSmall } from "./QuestionSmall";
import { QuestionSolidMedium } from "./QuestionSolidMedium";
import { QuestionSolidSmall } from "./QuestionSolidSmall";
import { ReactMedium } from "./ReactMedium";
import { ReactSmall } from "./ReactSmall";
import { RefreshMedium } from "./RefreshMedium";
import { RefreshSmall } from "./RefreshSmall";
import { RepeatMedium } from "./RepeatMedium";
import { RepeatSmall } from "./RepeatSmall";
import { RocketLaunchMedium } from "./RocketLaunchMedium";
import { RocketLaunchSmall } from "./RocketLaunchSmall";
import { RotateLeftMedium } from "./RotateLeftMedium";
import { RotateLeftSmall } from "./RotateLeftSmall";
import { RotateRightMedium } from "./RotateRightMedium";
import { RotateRightSmall } from "./RotateRightSmall";
import { SaveMedium } from "./SaveMedium";
import { SaveSmall } from "./SaveSmall";
import { ScissorsMedium } from "./ScissorsMedium";
import { ScissorsSmall } from "./ScissorsSmall";
import { ScreenShareMedium } from "./ScreenShareMedium";
import { ScreenShareSmall } from "./ScreenShareSmall";
import { SearchMedium } from "./SearchMedium";
import { SearchSmall } from "./SearchSmall";
import { SendMedium } from "./SendMedium";
import { SendSmall } from "./SendSmall";
import { SettingsMedium } from "./SettingsMedium";
import { SettingsSmall } from "./SettingsSmall";
import { SettingsSolidMedium } from "./SettingsSolidMedium";
import { SettingsSolidSmall } from "./SettingsSolidSmall";
import { ShareMedium } from "./ShareMedium";
import { ShareSmall } from "./ShareSmall";
import { ShieldAlertMedium } from "./ShieldAlertMedium";
import { ShieldAlertSmall } from "./ShieldAlertSmall";
import { ShieldCheckMedium } from "./ShieldCheckMedium";
import { ShieldCheckSmall } from "./ShieldCheckSmall";
import { ShieldCloseMedium } from "./ShieldCloseMedium";
import { ShieldCloseSmall } from "./ShieldCloseSmall";
import { ShieldKeyMedium } from "./ShieldKeyMedium";
import { ShieldKeySmall } from "./ShieldKeySmall";
import { ShieldMedium } from "./ShieldMedium";
import { ShieldSlashMedium } from "./ShieldSlashMedium";
import { ShieldSlashSmall } from "./ShieldSlashSmall";
import { ShieldSmall } from "./ShieldSmall";
import { ShoppingBagMedium } from "./ShoppingBagMedium";
import { ShoppingBagSmall } from "./ShoppingBagSmall";
import { ShoppingBasketMedium } from "./ShoppingBasketMedium";
import { ShoppingBasketSmall } from "./ShoppingBasketSmall";
import { ShoppingCartFastMedium } from "./ShoppingCartFastMedium";
import { ShoppingCartFastSmall } from "./ShoppingCartFastSmall";
import { ShoppingCartMedium } from "./ShoppingCartMedium";
import { ShoppingCartSmall } from "./ShoppingCartSmall";
import { ShoppingCartSolidMedium } from "./ShoppingCartSolidMedium";
import { ShoppingCartSolidSmall } from "./ShoppingCartSolidSmall";
import { SignalMedium } from "./SignalMedium";
import { SignalSmall } from "./SignalSmall";
import { SignatureLockMedium } from "./SignatureLockMedium";
import { SignatureLockSmall } from "./SignatureLockSmall";
import { SignatureMedium } from "./SignatureMedium";
import { SignatureSmall } from "./SignatureSmall";
import { SkullMedium } from "./SkullMedium";
import { SkullSmall } from "./SkullSmall";
import { SlashMedium } from "./SlashMedium";
import { SlashSmall } from "./SlashSmall";
import { SliderMedium } from "./SliderMedium";
import { SliderSmall } from "./SliderSmall";
import { Sort19Medium } from "./Sort19Medium";
import { Sort19Small } from "./Sort19Small";
import { Sort91Medium } from "./Sort91Medium";
import { Sort91Small } from "./Sort91Small";
import { SortAZMedium } from "./SortAZMedium";
import { SortAZSmall } from "./SortAZSmall";
import { SortAscMedium } from "./SortAscMedium";
import { SortAscSmall } from "./SortAscSmall";
import { SortDescMedium } from "./SortDescMedium";
import { SortDescSmall } from "./SortDescSmall";
import { SortZAMedium } from "./SortZAMedium";
import { SortZASmall } from "./SortZASmall";
import { SplitMedium } from "./SplitMedium";
import { SplitSmall } from "./SplitSmall";
import { StarMedium } from "./StarMedium";
import { StarSmall } from "./StarSmall";
import { StarSolidMedium } from "./StarSolidMedium";
import { StarSolidSmall } from "./StarSolidSmall";
import { StopwatchMedium } from "./StopwatchMedium";
import { StopwatchSmall } from "./StopwatchSmall";
import { StoreMedium } from "./StoreMedium";
import { StoreSmall } from "./StoreSmall";
import { SwitchOffMedium } from "./SwitchOffMedium";
import { SwitchOffSmall } from "./SwitchOffSmall";
import { SwitchOffSolidMedium } from "./SwitchOffSolidMedium";
import { SwitchOffSolidSmall } from "./SwitchOffSolidSmall";
import { SwitchOnMedium } from "./SwitchOnMedium";
import { SwitchOnSmall } from "./SwitchOnSmall";
import { SwitchOnSolidMedium } from "./SwitchOnSolidMedium";
import { SwitchOnSolidSmall } from "./SwitchOnSolidSmall";
import { TableMedium } from "./TableMedium";
import { TableSmall } from "./TableSmall";
import { TabletMedium } from "./TabletMedium";
import { TabletSmall } from "./TabletSmall";
import { TagMedium } from "./TagMedium";
import { TagSmall } from "./TagSmall";
import { TallyMedium } from "./TallyMedium";
import { TallySmall } from "./TallySmall";
import { TallySolidMedium } from "./TallySolidMedium";
import { TallySolidSmall } from "./TallySolidSmall";
import { TargetMedium } from "./TargetMedium";
import { TargetSmall } from "./TargetSmall";
import { TestMedium } from "./TestMedium";
import { TestSmall } from "./TestSmall";
import { TextMedium } from "./TextMedium";
import { TextSizeMedium } from "./TextSizeMedium";
import { TextSizeSmall } from "./TextSizeSmall";
import { TextSmall } from "./TextSmall";
import { ThumbsDownMedium } from "./ThumbsDownMedium";
import { ThumbsDownSmall } from "./ThumbsDownSmall";
import { ThumbsUpMedium } from "./ThumbsUpMedium";
import { ThumbsUpSmall } from "./ThumbsUpSmall";
import { TicketMedium } from "./TicketMedium";
import { TicketSmall } from "./TicketSmall";
import { TimelineMedium } from "./TimelineMedium";
import { TimelineSmall } from "./TimelineSmall";
import { TrashMedium } from "./TrashMedium";
import { TrashSmall } from "./TrashSmall";
import { TrendingDownMedium } from "./TrendingDownMedium";
import { TrendingDownSmall } from "./TrendingDownSmall";
import { TrendingUpMedium } from "./TrendingUpMedium";
import { TrendingUpSmall } from "./TrendingUpSmall";
import { UnlockMedium } from "./UnlockMedium";
import { UnlockSmall } from "./UnlockSmall";
import { UploadCloudMedium } from "./UploadCloudMedium";
import { UploadCloudSmall } from "./UploadCloudSmall";
import { UploadMedium } from "./UploadMedium";
import { UploadSmall } from "./UploadSmall";
import { UserCheckMedium } from "./UserCheckMedium";
import { UserCheckSmall } from "./UserCheckSmall";
import { UserMedium } from "./UserMedium";
import { UserMinusMedium } from "./UserMinusMedium";
import { UserMinusSmall } from "./UserMinusSmall";
import { UserPlusMedium } from "./UserPlusMedium";
import { UserPlusSmall } from "./UserPlusSmall";
import { UserSmall } from "./UserSmall";
import { UserXMedium } from "./UserXMedium";
import { UserXSmall } from "./UserXSmall";
import { VideoMedium } from "./VideoMedium";
import { VideoSmall } from "./VideoSmall";
import { WalletMedium } from "./WalletMedium";
import { WalletSmall } from "./WalletSmall";
import { WandMedium } from "./WandMedium";
import { WandSmall } from "./WandSmall";
import { WebhookMedium } from "./WebhookMedium";
import { WebhookSmall } from "./WebhookSmall";
import { WifiMedium } from "./WifiMedium";
import { WifiOffMedium } from "./WifiOffMedium";
import { WifiOffSmall } from "./WifiOffSmall";
import { WifiSmall } from "./WifiSmall";
import { WorkflowMedium } from "./WorkflowMedium";
import { WorkflowSmall } from "./WorkflowSmall";
import { WorkflowSolidMedium } from "./WorkflowSolidMedium";
import { WorkflowSolidSmall } from "./WorkflowSolidSmall";
import { WrenchMedium } from "./WrenchMedium";
import { WrenchSmall } from "./WrenchSmall";
import { ZoomInMedium } from "./ZoomInMedium";
import { ZoomInSmall } from "./ZoomInSmall";
import { ZoomOutMedium } from "./ZoomOutMedium";
import { ZoomOutSmall } from "./ZoomOutSmall";
var handler = {
  get: function get(target, property) {
    var _target$property;
    return (_target$property = target[property]) !== null && _target$property !== void 0 ? _target$property : target.medium;
  }
};
var AbTest = new Proxy({
  medium: AbTestMedium,
  small: AbTestSmall
}, handler);
var Activity = new Proxy({
  medium: ActivityMedium,
  small: ActivitySmall
}, handler);
var ActivitySolid = new Proxy({
  medium: ActivitySolidMedium,
  small: ActivitySolidSmall
}, handler);
var AlarmClock = new Proxy({
  medium: AlarmClockMedium,
  small: AlarmClockSmall
}, handler);
var Album = new Proxy({
  medium: AlbumMedium,
  small: AlbumSmall
}, handler);
var AlignCenter = new Proxy({
  medium: AlignCenterMedium,
  small: AlignCenterSmall
}, handler);
var AlignLeft = new Proxy({
  medium: AlignLeftMedium,
  small: AlignLeftSmall
}, handler);
var AlignRight = new Proxy({
  medium: AlignRightMedium,
  small: AlignRightSmall
}, handler);
var AndroidSolid = new Proxy({
  medium: AndroidSolidMedium,
  small: AndroidSolidSmall
}, handler);
var App = new Proxy({
  medium: AppMedium,
  small: AppSmall
}, handler);
var AppSolid = new Proxy({
  medium: AppSolidMedium,
  small: AppSolidSmall
}, handler);
var AppleSolid = new Proxy({
  medium: AppleSolidMedium,
  small: AppleSolidSmall
}, handler);
var Archive = new Proxy({
  medium: ArchiveMedium,
  small: ArchiveSmall
}, handler);
var ArrowDownLeft = new Proxy({
  medium: ArrowDownLeftMedium,
  small: ArrowDownLeftSmall
}, handler);
var ArrowDown = new Proxy({
  medium: ArrowDownMedium,
  small: ArrowDownSmall
}, handler);
var ArrowDownRight = new Proxy({
  medium: ArrowDownRightMedium,
  small: ArrowDownRightSmall
}, handler);
var ArrowDownUp = new Proxy({
  medium: ArrowDownUpMedium,
  small: ArrowDownUpSmall
}, handler);
var ArrowLeft = new Proxy({
  medium: ArrowLeftMedium,
  small: ArrowLeftSmall
}, handler);
var ArrowRightLeft = new Proxy({
  medium: ArrowRightLeftMedium,
  small: ArrowRightLeftSmall
}, handler);
var ArrowRight = new Proxy({
  medium: ArrowRightMedium,
  small: ArrowRightSmall
}, handler);
var ArrowUpDown = new Proxy({
  medium: ArrowUpDownMedium,
  small: ArrowUpDownSmall
}, handler);
var ArrowUpLeft = new Proxy({
  medium: ArrowUpLeftMedium,
  small: ArrowUpLeftSmall
}, handler);
var ArrowUp = new Proxy({
  medium: ArrowUpMedium,
  small: ArrowUpSmall
}, handler);
var ArrowUpRight = new Proxy({
  medium: ArrowUpRightMedium,
  small: ArrowUpRightSmall
}, handler);
var Asterisk = new Proxy({
  medium: AsteriskMedium,
  small: AsteriskSmall
}, handler);
var AtSign = new Proxy({
  medium: AtSignMedium,
  small: AtSignSmall
}, handler);
var Bank = new Proxy({
  medium: BankMedium,
  small: BankSmall
}, handler);
var Banknote = new Proxy({
  medium: BanknoteMedium,
  small: BanknoteSmall
}, handler);
var BanknoteSolid = new Proxy({
  medium: BanknoteSolidMedium,
  small: BanknoteSolidSmall
}, handler);
var Bell = new Proxy({
  medium: BellMedium,
  small: BellSmall
}, handler);
var Bitcoin = new Proxy({
  medium: BitcoinMedium,
  small: BitcoinSmall
}, handler);
var Bolt = new Proxy({
  medium: BoltMedium,
  small: BoltSmall
}, handler);
var BookClosed = new Proxy({
  medium: BookClosedMedium,
  small: BookClosedSmall
}, handler);
var BookOpen = new Proxy({
  medium: BookOpenMedium,
  small: BookOpenSmall
}, handler);
var BookOpenSolid = new Proxy({
  medium: BookOpenSolidMedium,
  small: BookOpenSolidSmall
}, handler);
var Bookmark = new Proxy({
  medium: BookmarkMedium,
  small: BookmarkSmall
}, handler);
var Box = new Proxy({
  medium: BoxMedium,
  small: BoxSmall
}, handler);
var BoxSelect = new Proxy({
  medium: BoxSelectMedium,
  small: BoxSelectSmall
}, handler);
var Brush = new Proxy({
  medium: BrushMedium,
  small: BrushSmall
}, handler);
var Building = new Proxy({
  medium: BuildingMedium,
  small: BuildingSmall
}, handler);
var Bus = new Proxy({
  medium: BusMedium,
  small: BusSmall
}, handler);
var Calculcator = new Proxy({
  medium: CalculcatorMedium,
  small: CalculcatorSmall
}, handler);
var Calendar = new Proxy({
  medium: CalendarMedium,
  small: CalendarSmall
}, handler);
var Camera = new Proxy({
  medium: CameraMedium,
  small: CameraSmall
}, handler);
var Car = new Proxy({
  medium: CarMedium,
  small: CarSmall
}, handler);
var ChartArea = new Proxy({
  medium: ChartAreaMedium,
  small: ChartAreaSmall
}, handler);
var ChartColumn = new Proxy({
  medium: ChartColumnMedium,
  small: ChartColumnSmall
}, handler);
var ChartColumnSolid = new Proxy({
  medium: ChartColumnSolidMedium,
  small: ChartColumnSolidSmall
}, handler);
var ChartCombo = new Proxy({
  medium: ChartComboMedium,
  small: ChartComboSmall
}, handler);
var ChartHandle = new Proxy({
  medium: ChartHandleMedium,
  small: ChartHandleSmall
}, handler);
var ChartLine = new Proxy({
  medium: ChartLineMedium,
  small: ChartLineSmall
}, handler);
var ChartLineSolid = new Proxy({
  medium: ChartLineSolidMedium,
  small: ChartLineSolidSmall
}, handler);
var ChartPie = new Proxy({
  medium: ChartPieMedium,
  small: ChartPieSmall
}, handler);
var ChartPieSolid = new Proxy({
  medium: ChartPieSolidMedium,
  small: ChartPieSolidSmall
}, handler);
var ChartScatter = new Proxy({
  medium: ChartScatterMedium,
  small: ChartScatterSmall
}, handler);
var CheckCircle = new Proxy({
  medium: CheckCircleMedium,
  small: CheckCircleSmall
}, handler);
var CheckCircleSolid = new Proxy({
  medium: CheckCircleSolidMedium,
  small: CheckCircleSolidSmall
}, handler);
var Check = new Proxy({
  medium: CheckMedium,
  small: CheckSmall
}, handler);
var CheckSolid = new Proxy({
  medium: CheckSolidMedium,
  small: CheckSolidSmall
}, handler);
var ChevronDown = new Proxy({
  medium: ChevronDownMedium,
  small: ChevronDownSmall
}, handler);
var ChevronFirst = new Proxy({
  medium: ChevronFirstMedium,
  small: ChevronFirstSmall
}, handler);
var ChevronLast = new Proxy({
  medium: ChevronLastMedium,
  small: ChevronLastSmall
}, handler);
var ChevronLeft = new Proxy({
  medium: ChevronLeftMedium,
  small: ChevronLeftSmall
}, handler);
var ChevronRight = new Proxy({
  medium: ChevronRightMedium,
  small: ChevronRightSmall
}, handler);
var ChevronUp = new Proxy({
  medium: ChevronUpMedium,
  small: ChevronUpSmall
}, handler);
var ChevronsDown = new Proxy({
  medium: ChevronsDownMedium,
  small: ChevronsDownSmall
}, handler);
var ChevronsDownUp = new Proxy({
  medium: ChevronsDownUpMedium,
  small: ChevronsDownUpSmall
}, handler);
var ChevronsLeft = new Proxy({
  medium: ChevronsLeftMedium,
  small: ChevronsLeftSmall
}, handler);
var ChevronsRight = new Proxy({
  medium: ChevronsRightMedium,
  small: ChevronsRightSmall
}, handler);
var ChevronsUpDown = new Proxy({
  medium: ChevronsUpDownMedium,
  small: ChevronsUpDownSmall
}, handler);
var ChevronsUp = new Proxy({
  medium: ChevronsUpMedium,
  small: ChevronsUpSmall
}, handler);
var ClipboardCheck = new Proxy({
  medium: ClipboardCheckMedium,
  small: ClipboardCheckSmall
}, handler);
var ClipboardList = new Proxy({
  medium: ClipboardListMedium,
  small: ClipboardListSmall
}, handler);
var Clipboard = new Proxy({
  medium: ClipboardMedium,
  small: ClipboardSmall
}, handler);
var Clock = new Proxy({
  medium: ClockMedium,
  small: ClockSmall
}, handler);
var ClockSolid = new Proxy({
  medium: ClockSolidMedium,
  small: ClockSolidSmall
}, handler);
var CloseCircle = new Proxy({
  medium: CloseCircleMedium,
  small: CloseCircleSmall
}, handler);
var CloseCircleSolid = new Proxy({
  medium: CloseCircleSolidMedium,
  small: CloseCircleSolidSmall
}, handler);
var Close = new Proxy({
  medium: CloseMedium,
  small: CloseSmall
}, handler);
var CloseSolid = new Proxy({
  medium: CloseSolidMedium,
  small: CloseSolidSmall
}, handler);
var Cloud = new Proxy({
  medium: CloudMedium,
  small: CloudSmall
}, handler);
var CodeBranch = new Proxy({
  medium: CodeBranchMedium,
  small: CodeBranchSmall
}, handler);
var CodeBranchPlus = new Proxy({
  medium: CodeBranchPlusMedium,
  small: CodeBranchPlusSmall
}, handler);
var CodeClose = new Proxy({
  medium: CodeCloseMedium,
  small: CodeCloseSmall
}, handler);
var CodeCloseSolid = new Proxy({
  medium: CodeCloseSolidMedium,
  small: CodeCloseSolidSmall
}, handler);
var CodeCommit = new Proxy({
  medium: CodeCommitMedium,
  small: CodeCommitSmall
}, handler);
var CodeFork = new Proxy({
  medium: CodeForkMedium,
  small: CodeForkSmall
}, handler);
var CodeMerge = new Proxy({
  medium: CodeMergeMedium,
  small: CodeMergeSmall
}, handler);
var CodeMergeSolid = new Proxy({
  medium: CodeMergeSolidMedium,
  small: CodeMergeSolidSmall
}, handler);
var CodeOpen = new Proxy({
  medium: CodeOpenMedium,
  small: CodeOpenSmall
}, handler);
var CodePullRequest = new Proxy({
  medium: CodePullRequestMedium,
  small: CodePullRequestSmall
}, handler);
var Coins = new Proxy({
  medium: CoinsMedium,
  small: CoinsSmall
}, handler);
var Compress = new Proxy({
  medium: CompressMedium,
  small: CompressSmall
}, handler);
var Condition = new Proxy({
  medium: ConditionMedium,
  small: ConditionSmall
}, handler);
var Contact = new Proxy({
  medium: ContactMedium,
  small: ContactSmall
}, handler);
var ContainCaseSensitive = new Proxy({
  medium: ContainCaseSensitiveMedium,
  small: ContainCaseSensitiveSmall
}, handler);
var Contain = new Proxy({
  medium: ContainMedium,
  small: ContainSmall
}, handler);
var Copy = new Proxy({
  medium: CopyMedium,
  small: CopySmall
}, handler);
var CornerDownLeft = new Proxy({
  medium: CornerDownLeftMedium,
  small: CornerDownLeftSmall
}, handler);
var CornerDownRight = new Proxy({
  medium: CornerDownRightMedium,
  small: CornerDownRightSmall
}, handler);
var CornerLeftDown = new Proxy({
  medium: CornerLeftDownMedium,
  small: CornerLeftDownSmall
}, handler);
var CornerLeftUp = new Proxy({
  medium: CornerLeftUpMedium,
  small: CornerLeftUpSmall
}, handler);
var CornerRightDown = new Proxy({
  medium: CornerRightDownMedium,
  small: CornerRightDownSmall
}, handler);
var CornerRightUp = new Proxy({
  medium: CornerRightUpMedium,
  small: CornerRightUpSmall
}, handler);
var CornerUpLeft = new Proxy({
  medium: CornerUpLeftMedium,
  small: CornerUpLeftSmall
}, handler);
var CornerUpRight = new Proxy({
  medium: CornerUpRightMedium,
  small: CornerUpRightSmall
}, handler);
var CreditCard = new Proxy({
  medium: CreditCardMedium,
  small: CreditCardSmall
}, handler);
var Crosshair = new Proxy({
  medium: CrosshairMedium,
  small: CrosshairSmall
}, handler);
var Crown = new Proxy({
  medium: CrownMedium,
  small: CrownSmall
}, handler);
var Cube = new Proxy({
  medium: CubeMedium,
  small: CubeSmall
}, handler);
var Currency = new Proxy({
  medium: CurrencyMedium,
  small: CurrencySmall
}, handler);
var Dashboard = new Proxy({
  medium: DashboardMedium,
  small: DashboardSmall
}, handler);
var Database = new Proxy({
  medium: DatabaseMedium,
  small: DatabaseSmall
}, handler);
var Desktop = new Proxy({
  medium: DesktopMedium,
  small: DesktopSmall
}, handler);
var DiscordSolid = new Proxy({
  medium: DiscordSolidMedium,
  small: DiscordSolidSmall
}, handler);
var Divide = new Proxy({
  medium: DivideMedium,
  small: DivideSmall
}, handler);
var Dollar = new Proxy({
  medium: DollarMedium,
  small: DollarSmall
}, handler);
var DownloadCloud = new Proxy({
  medium: DownloadCloudMedium,
  small: DownloadCloudSmall
}, handler);
var Download = new Proxy({
  medium: DownloadMedium,
  small: DownloadSmall
}, handler);
var Edit = new Proxy({
  medium: EditMedium,
  small: EditSmall
}, handler);
var Empty = new Proxy({
  medium: EmptyMedium,
  small: EmptySmall
}, handler);
var Envelope = new Proxy({
  medium: EnvelopeMedium,
  small: EnvelopeSmall
}, handler);
var Equal = new Proxy({
  medium: EqualMedium,
  small: EqualSmall
}, handler);
var EqualSlash = new Proxy({
  medium: EqualSlashMedium,
  small: EqualSlashSmall
}, handler);
var Euro = new Proxy({
  medium: EuroMedium,
  small: EuroSmall
}, handler);
var Exclamation = new Proxy({
  medium: ExclamationMedium,
  small: ExclamationSmall
}, handler);
var ExclamationSolid = new Proxy({
  medium: ExclamationSolidMedium,
  small: ExclamationSolidSmall
}, handler);
var ExclamationTriangle = new Proxy({
  medium: ExclamationTriangleMedium,
  small: ExclamationTriangleSmall
}, handler);
var ExclamationTriangleSolid = new Proxy({
  medium: ExclamationTriangleSolidMedium,
  small: ExclamationTriangleSolidSmall
}, handler);
var Expand = new Proxy({
  medium: ExpandMedium,
  small: ExpandSmall
}, handler);
var ExternalLink = new Proxy({
  medium: ExternalLinkMedium,
  small: ExternalLinkSmall
}, handler);
var Eye = new Proxy({
  medium: EyeMedium,
  small: EyeSmall
}, handler);
var EyeSlash = new Proxy({
  medium: EyeSlashMedium,
  small: EyeSlashSmall
}, handler);
var FileCheck = new Proxy({
  medium: FileCheckMedium,
  small: FileCheckSmall
}, handler);
var FileCode = new Proxy({
  medium: FileCodeMedium,
  small: FileCodeSmall
}, handler);
var FileExport = new Proxy({
  medium: FileExportMedium,
  small: FileExportSmall
}, handler);
var FileImport = new Proxy({
  medium: FileImportMedium,
  small: FileImportSmall
}, handler);
var File = new Proxy({
  medium: FileMedium,
  small: FileSmall
}, handler);
var FileMinus = new Proxy({
  medium: FileMinusMedium,
  small: FileMinusSmall
}, handler);
var FilePlus = new Proxy({
  medium: FilePlusMedium,
  small: FilePlusSmall
}, handler);
var FileSpreadsheet = new Proxy({
  medium: FileSpreadsheetMedium,
  small: FileSpreadsheetSmall
}, handler);
var FileText = new Proxy({
  medium: FileTextMedium,
  small: FileTextSmall
}, handler);
var Files = new Proxy({
  medium: FilesMedium,
  small: FilesSmall
}, handler);
var Filter = new Proxy({
  medium: FilterMedium,
  small: FilterSmall
}, handler);
var Flag = new Proxy({
  medium: FlagMedium,
  small: FlagSmall
}, handler);
var Folder = new Proxy({
  medium: FolderMedium,
  small: FolderSmall
}, handler);
var FolderOpen = new Proxy({
  medium: FolderOpenMedium,
  small: FolderOpenSmall
}, handler);
var FontCase = new Proxy({
  medium: FontCaseMedium,
  small: FontCaseSmall
}, handler);
var Font = new Proxy({
  medium: FontMedium,
  small: FontSmall
}, handler);
var FormInput = new Proxy({
  medium: FormInputMedium,
  small: FormInputSmall
}, handler);
var Forward = new Proxy({
  medium: ForwardMedium,
  small: ForwardSmall
}, handler);
var Gauge = new Proxy({
  medium: GaugeMedium,
  small: GaugeSmall
}, handler);
var Gem = new Proxy({
  medium: GemMedium,
  small: GemSmall
}, handler);
var Gift = new Proxy({
  medium: GiftMedium,
  small: GiftSmall
}, handler);
var Github = new Proxy({
  medium: GithubMedium,
  small: GithubSmall
}, handler);
var Glasses = new Proxy({
  medium: GlassesMedium,
  small: GlassesSmall
}, handler);
var Globe = new Proxy({
  medium: GlobeMedium,
  small: GlobeSmall
}, handler);
var GreaterThanEqual = new Proxy({
  medium: GreaterThanEqualMedium,
  small: GreaterThanEqualSmall
}, handler);
var GreaterThan = new Proxy({
  medium: GreaterThanMedium,
  small: GreaterThanSmall
}, handler);
var Grid = new Proxy({
  medium: GridMedium,
  small: GridSmall
}, handler);
var GripHorizontal = new Proxy({
  medium: GripHorizontalMedium,
  small: GripHorizontalSmall
}, handler);
var GripVertical = new Proxy({
  medium: GripVerticalMedium,
  small: GripVerticalSmall
}, handler);
var Hammer = new Proxy({
  medium: HammerMedium,
  small: HammerSmall
}, handler);
var Hash = new Proxy({
  medium: HashMedium,
  small: HashSmall
}, handler);
var Heart = new Proxy({
  medium: HeartMedium,
  small: HeartSmall
}, handler);
var HeartSolid = new Proxy({
  medium: HeartSolidMedium,
  small: HeartSolidSmall
}, handler);
var Highlighter = new Proxy({
  medium: HighlighterMedium,
  small: HighlighterSmall
}, handler);
var Home = new Proxy({
  medium: HomeMedium,
  small: HomeSmall
}, handler);
var HomeSolid = new Proxy({
  medium: HomeSolidMedium,
  small: HomeSolidSmall
}, handler);
var ICursor = new Proxy({
  medium: ICursorMedium,
  small: ICursorSmall
}, handler);
var Image = new Proxy({
  medium: ImageMedium,
  small: ImageSmall
}, handler);
var InBetween = new Proxy({
  medium: InBetweenMedium,
  small: InBetweenSmall
}, handler);
var InfoCircle = new Proxy({
  medium: InfoCircleMedium,
  small: InfoCircleSmall
}, handler);
var InfoCircleSolid = new Proxy({
  medium: InfoCircleSolidMedium,
  small: InfoCircleSolidSmall
}, handler);
var Info = new Proxy({
  medium: InfoMedium,
  small: InfoSmall
}, handler);
var InfoSolid = new Proxy({
  medium: InfoSolidMedium,
  small: InfoSolidSmall
}, handler);
var Integrations = new Proxy({
  medium: IntegrationsMedium,
  small: IntegrationsSmall
}, handler);
var IntegrationsSolid = new Proxy({
  medium: IntegrationsSolidMedium,
  small: IntegrationsSolidSmall
}, handler);
var Key = new Proxy({
  medium: KeyMedium,
  small: KeySmall
}, handler);
var Laptop = new Proxy({
  medium: LaptopMedium,
  small: LaptopSmall
}, handler);
var Layers = new Proxy({
  medium: LayersMedium,
  small: LayersSmall
}, handler);
var LessThanEqual = new Proxy({
  medium: LessThanEqualMedium,
  small: LessThanEqualSmall
}, handler);
var LessThan = new Proxy({
  medium: LessThanMedium,
  small: LessThanSmall
}, handler);
var Library = new Proxy({
  medium: LibraryMedium,
  small: LibrarySmall
}, handler);
var Lightbulb = new Proxy({
  medium: LightbulbMedium,
  small: LightbulbSmall
}, handler);
var Link = new Proxy({
  medium: LinkMedium,
  small: LinkSmall
}, handler);
var LinkSlash = new Proxy({
  medium: LinkSlashMedium,
  small: LinkSlashSmall
}, handler);
var List = new Proxy({
  medium: ListMedium,
  small: ListSmall
}, handler);
var ListSolid = new Proxy({
  medium: ListSolidMedium,
  small: ListSolidSmall
}, handler);
var Loader = new Proxy({
  medium: LoaderMedium,
  small: LoaderSmall
}, handler);
var LocationFixed = new Proxy({
  medium: LocationFixedMedium,
  small: LocationFixedSmall
}, handler);
var Location = new Proxy({
  medium: LocationMedium,
  small: LocationSmall
}, handler);
var Lock = new Proxy({
  medium: LockMedium,
  small: LockSmall
}, handler);
var LockSolid = new Proxy({
  medium: LockSolidMedium,
  small: LockSolidSmall
}, handler);
var LogIn = new Proxy({
  medium: LogInMedium,
  small: LogInSmall
}, handler);
var LogOut = new Proxy({
  medium: LogOutMedium,
  small: LogOutSmall
}, handler);
var LogOutSolid = new Proxy({
  medium: LogOutSolidMedium,
  small: LogOutSolidSmall
}, handler);
var Map = new Proxy({
  medium: MapMedium,
  small: MapSmall
}, handler);
var MapPin = new Proxy({
  medium: MapPinMedium,
  small: MapPinSmall
}, handler);
var Maximise = new Proxy({
  medium: MaximiseMedium,
  small: MaximiseSmall
}, handler);
var Megaphone = new Proxy({
  medium: MegaphoneMedium,
  small: MegaphoneSmall
}, handler);
var Menu = new Proxy({
  medium: MenuMedium,
  small: MenuSmall
}, handler);
var Merge = new Proxy({
  medium: MergeMedium,
  small: MergeSmall
}, handler);
var Message = new Proxy({
  medium: MessageMedium,
  small: MessageSmall
}, handler);
var MessageSolid = new Proxy({
  medium: MessageSolidMedium,
  small: MessageSolidSmall
}, handler);
var Microchip = new Proxy({
  medium: MicrochipMedium,
  small: MicrochipSmall
}, handler);
var Minimise = new Proxy({
  medium: MinimiseMedium,
  small: MinimiseSmall
}, handler);
var MinusCircle = new Proxy({
  medium: MinusCircleMedium,
  small: MinusCircleSmall
}, handler);
var MinusCircleSolid = new Proxy({
  medium: MinusCircleSolidMedium,
  small: MinusCircleSolidSmall
}, handler);
var Minus = new Proxy({
  medium: MinusMedium,
  small: MinusSmall
}, handler);
var MinusSolid = new Proxy({
  medium: MinusSolidMedium,
  small: MinusSolidSmall
}, handler);
var MoreHorizontal = new Proxy({
  medium: MoreHorizontalMedium,
  small: MoreHorizontalSmall
}, handler);
var MoreVertical = new Proxy({
  medium: MoreVerticalMedium,
  small: MoreVerticalSmall
}, handler);
var MoveDiagonal1 = new Proxy({
  medium: MoveDiagonal1Medium,
  small: MoveDiagonal1Small
}, handler);
var MoveDiagonal2 = new Proxy({
  medium: MoveDiagonal2Medium,
  small: MoveDiagonal2Small
}, handler);
var MoveHorizontal = new Proxy({
  medium: MoveHorizontalMedium,
  small: MoveHorizontalSmall
}, handler);
var Move = new Proxy({
  medium: MoveMedium,
  small: MoveSmall
}, handler);
var MoveVertical = new Proxy({
  medium: MoveVerticalMedium,
  small: MoveVerticalSmall
}, handler);
var Mute = new Proxy({
  medium: MuteMedium,
  small: MuteSmall
}, handler);
var NetworkWired = new Proxy({
  medium: NetworkWiredMedium,
  small: NetworkWiredSmall
}, handler);
var News = new Proxy({
  medium: NewsMedium,
  small: NewsSmall
}, handler);
var NotContainCaseSensitive = new Proxy({
  medium: NotContainCaseSensitiveMedium,
  small: NotContainCaseSensitiveSmall
}, handler);
var NotContain = new Proxy({
  medium: NotContainMedium,
  small: NotContainSmall
}, handler);
var NotEmpty = new Proxy({
  medium: NotEmptyMedium,
  small: NotEmptySmall
}, handler);
var NotOneOf = new Proxy({
  medium: NotOneOfMedium,
  small: NotOneOfSmall
}, handler);
var OneOf = new Proxy({
  medium: OneOfMedium,
  small: OneOfSmall
}, handler);
var Palette = new Proxy({
  medium: PaletteMedium,
  small: PaletteSmall
}, handler);
var PanelClose = new Proxy({
  medium: PanelCloseMedium
}, handler);
var PanelOpen = new Proxy({
  medium: PanelOpenMedium
}, handler);
var Paperclip = new Proxy({
  medium: PaperclipMedium,
  small: PaperclipSmall
}, handler);
var Pen = new Proxy({
  medium: PenMedium,
  small: PenSmall
}, handler);
var Pencil = new Proxy({
  medium: PencilMedium,
  small: PencilSmall
}, handler);
var Percent = new Proxy({
  medium: PercentMedium,
  small: PercentSmall
}, handler);
var Phone = new Proxy({
  medium: PhoneMedium,
  small: PhoneSmall
}, handler);
var Play = new Proxy({
  medium: PlayMedium,
  small: PlaySmall
}, handler);
var PlaySolid = new Proxy({
  medium: PlaySolidMedium,
  small: PlaySolidSmall
}, handler);
var Plug = new Proxy({
  medium: PlugMedium,
  small: PlugSmall
}, handler);
var PlusCircle = new Proxy({
  medium: PlusCircleMedium,
  small: PlusCircleSmall
}, handler);
var PlusCircleSolid = new Proxy({
  medium: PlusCircleSolidMedium,
  small: PlusCircleSolidSmall
}, handler);
var Plus = new Proxy({
  medium: PlusMedium,
  small: PlusSmall
}, handler);
var PlusSolid = new Proxy({
  medium: PlusSolidMedium,
  small: PlusSolidSmall
}, handler);
var Power = new Proxy({
  medium: PowerMedium,
  small: PowerSmall
}, handler);
var QuestionCircle = new Proxy({
  medium: QuestionCircleMedium,
  small: QuestionCircleSmall
}, handler);
var QuestionCircleSolid = new Proxy({
  medium: QuestionCircleSolidMedium,
  small: QuestionCircleSolidSmall
}, handler);
var Question = new Proxy({
  medium: QuestionMedium,
  small: QuestionSmall
}, handler);
var QuestionSolid = new Proxy({
  medium: QuestionSolidMedium,
  small: QuestionSolidSmall
}, handler);
var React = new Proxy({
  medium: ReactMedium,
  small: ReactSmall
}, handler);
var Refresh = new Proxy({
  medium: RefreshMedium,
  small: RefreshSmall
}, handler);
var Repeat = new Proxy({
  medium: RepeatMedium,
  small: RepeatSmall
}, handler);
var RocketLaunch = new Proxy({
  medium: RocketLaunchMedium,
  small: RocketLaunchSmall
}, handler);
var RotateLeft = new Proxy({
  medium: RotateLeftMedium,
  small: RotateLeftSmall
}, handler);
var RotateRight = new Proxy({
  medium: RotateRightMedium,
  small: RotateRightSmall
}, handler);
var Save = new Proxy({
  medium: SaveMedium,
  small: SaveSmall
}, handler);
var Scissors = new Proxy({
  medium: ScissorsMedium,
  small: ScissorsSmall
}, handler);
var ScreenShare = new Proxy({
  medium: ScreenShareMedium,
  small: ScreenShareSmall
}, handler);
var Search = new Proxy({
  medium: SearchMedium,
  small: SearchSmall
}, handler);
var Send = new Proxy({
  medium: SendMedium,
  small: SendSmall
}, handler);
var Settings = new Proxy({
  medium: SettingsMedium,
  small: SettingsSmall
}, handler);
var SettingsSolid = new Proxy({
  medium: SettingsSolidMedium,
  small: SettingsSolidSmall
}, handler);
var Share = new Proxy({
  medium: ShareMedium,
  small: ShareSmall
}, handler);
var ShieldAlert = new Proxy({
  medium: ShieldAlertMedium,
  small: ShieldAlertSmall
}, handler);
var ShieldCheck = new Proxy({
  medium: ShieldCheckMedium,
  small: ShieldCheckSmall
}, handler);
var ShieldClose = new Proxy({
  medium: ShieldCloseMedium,
  small: ShieldCloseSmall
}, handler);
var ShieldKey = new Proxy({
  medium: ShieldKeyMedium,
  small: ShieldKeySmall
}, handler);
var Shield = new Proxy({
  medium: ShieldMedium,
  small: ShieldSmall
}, handler);
var ShieldSlash = new Proxy({
  medium: ShieldSlashMedium,
  small: ShieldSlashSmall
}, handler);
var ShoppingBag = new Proxy({
  medium: ShoppingBagMedium,
  small: ShoppingBagSmall
}, handler);
var ShoppingBasket = new Proxy({
  medium: ShoppingBasketMedium,
  small: ShoppingBasketSmall
}, handler);
var ShoppingCartFast = new Proxy({
  medium: ShoppingCartFastMedium,
  small: ShoppingCartFastSmall
}, handler);
var ShoppingCart = new Proxy({
  medium: ShoppingCartMedium,
  small: ShoppingCartSmall
}, handler);
var ShoppingCartSolid = new Proxy({
  medium: ShoppingCartSolidMedium,
  small: ShoppingCartSolidSmall
}, handler);
var Signal = new Proxy({
  medium: SignalMedium,
  small: SignalSmall
}, handler);
var SignatureLock = new Proxy({
  medium: SignatureLockMedium,
  small: SignatureLockSmall
}, handler);
var Signature = new Proxy({
  medium: SignatureMedium,
  small: SignatureSmall
}, handler);
var Skull = new Proxy({
  medium: SkullMedium,
  small: SkullSmall
}, handler);
var Slash = new Proxy({
  medium: SlashMedium,
  small: SlashSmall
}, handler);
var Slider = new Proxy({
  medium: SliderMedium,
  small: SliderSmall
}, handler);
var Sort19 = new Proxy({
  medium: Sort19Medium,
  small: Sort19Small
}, handler);
var Sort91 = new Proxy({
  medium: Sort91Medium,
  small: Sort91Small
}, handler);
var SortAZ = new Proxy({
  medium: SortAZMedium,
  small: SortAZSmall
}, handler);
var SortAsc = new Proxy({
  medium: SortAscMedium,
  small: SortAscSmall
}, handler);
var SortDesc = new Proxy({
  medium: SortDescMedium,
  small: SortDescSmall
}, handler);
var SortZA = new Proxy({
  medium: SortZAMedium,
  small: SortZASmall
}, handler);
var Split = new Proxy({
  medium: SplitMedium,
  small: SplitSmall
}, handler);
var Star = new Proxy({
  medium: StarMedium,
  small: StarSmall
}, handler);
var StarSolid = new Proxy({
  medium: StarSolidMedium,
  small: StarSolidSmall
}, handler);
var Stopwatch = new Proxy({
  medium: StopwatchMedium,
  small: StopwatchSmall
}, handler);
var Store = new Proxy({
  medium: StoreMedium,
  small: StoreSmall
}, handler);
var SwitchOff = new Proxy({
  medium: SwitchOffMedium,
  small: SwitchOffSmall
}, handler);
var SwitchOffSolid = new Proxy({
  medium: SwitchOffSolidMedium,
  small: SwitchOffSolidSmall
}, handler);
var SwitchOn = new Proxy({
  medium: SwitchOnMedium,
  small: SwitchOnSmall
}, handler);
var SwitchOnSolid = new Proxy({
  medium: SwitchOnSolidMedium,
  small: SwitchOnSolidSmall
}, handler);
var Table = new Proxy({
  medium: TableMedium,
  small: TableSmall
}, handler);
var Tablet = new Proxy({
  medium: TabletMedium,
  small: TabletSmall
}, handler);
var Tag = new Proxy({
  medium: TagMedium,
  small: TagSmall
}, handler);
var Tally = new Proxy({
  medium: TallyMedium,
  small: TallySmall
}, handler);
var TallySolid = new Proxy({
  medium: TallySolidMedium,
  small: TallySolidSmall
}, handler);
var Target = new Proxy({
  medium: TargetMedium,
  small: TargetSmall
}, handler);
var Test = new Proxy({
  medium: TestMedium,
  small: TestSmall
}, handler);
var Text = new Proxy({
  medium: TextMedium,
  small: TextSmall
}, handler);
var TextSize = new Proxy({
  medium: TextSizeMedium,
  small: TextSizeSmall
}, handler);
var ThumbsDown = new Proxy({
  medium: ThumbsDownMedium,
  small: ThumbsDownSmall
}, handler);
var ThumbsUp = new Proxy({
  medium: ThumbsUpMedium,
  small: ThumbsUpSmall
}, handler);
var Ticket = new Proxy({
  medium: TicketMedium,
  small: TicketSmall
}, handler);
var Timeline = new Proxy({
  medium: TimelineMedium,
  small: TimelineSmall
}, handler);
var Trash = new Proxy({
  medium: TrashMedium,
  small: TrashSmall
}, handler);
var TrendingDown = new Proxy({
  medium: TrendingDownMedium,
  small: TrendingDownSmall
}, handler);
var TrendingUp = new Proxy({
  medium: TrendingUpMedium,
  small: TrendingUpSmall
}, handler);
var Unlock = new Proxy({
  medium: UnlockMedium,
  small: UnlockSmall
}, handler);
var UploadCloud = new Proxy({
  medium: UploadCloudMedium,
  small: UploadCloudSmall
}, handler);
var Upload = new Proxy({
  medium: UploadMedium,
  small: UploadSmall
}, handler);
var UserCheck = new Proxy({
  medium: UserCheckMedium,
  small: UserCheckSmall
}, handler);
var User = new Proxy({
  medium: UserMedium,
  small: UserSmall
}, handler);
var UserMinus = new Proxy({
  medium: UserMinusMedium,
  small: UserMinusSmall
}, handler);
var UserPlus = new Proxy({
  medium: UserPlusMedium,
  small: UserPlusSmall
}, handler);
var UserX = new Proxy({
  medium: UserXMedium,
  small: UserXSmall
}, handler);
var Video = new Proxy({
  medium: VideoMedium,
  small: VideoSmall
}, handler);
var Wallet = new Proxy({
  medium: WalletMedium,
  small: WalletSmall
}, handler);
var Wand = new Proxy({
  medium: WandMedium,
  small: WandSmall
}, handler);
var Webhook = new Proxy({
  medium: WebhookMedium,
  small: WebhookSmall
}, handler);
var Wifi = new Proxy({
  medium: WifiMedium,
  small: WifiSmall
}, handler);
var WifiOff = new Proxy({
  medium: WifiOffMedium,
  small: WifiOffSmall
}, handler);
var Workflow = new Proxy({
  medium: WorkflowMedium,
  small: WorkflowSmall
}, handler);
var WorkflowSolid = new Proxy({
  medium: WorkflowSolidMedium,
  small: WorkflowSolidSmall
}, handler);
var Wrench = new Proxy({
  medium: WrenchMedium,
  small: WrenchSmall
}, handler);
var ZoomIn = new Proxy({
  medium: ZoomInMedium,
  small: ZoomInSmall
}, handler);
var ZoomOut = new Proxy({
  medium: ZoomOutMedium,
  small: ZoomOutSmall
}, handler);
export { AbTest, Activity, ActivitySolid, AlarmClock, Album, AlignCenter, AlignLeft, AlignRight, AndroidSolid, App, AppSolid, AppleSolid, Archive, ArrowDown, ArrowDownLeft, ArrowDownRight, ArrowDownUp, ArrowLeft, ArrowRight, ArrowRightLeft, ArrowUp, ArrowUpDown, ArrowUpLeft, ArrowUpRight, Asterisk, AtSign, Bank, Banknote, BanknoteSolid, Bell, Bitcoin, Bolt, BookClosed, BookOpen, BookOpenSolid, Bookmark, Box, BoxSelect, Brush, Building, Bus, Calculcator, Calendar, Camera, Car, ChartArea, ChartColumn, ChartColumnSolid, ChartCombo, ChartHandle, ChartLine, ChartLineSolid, ChartPie, ChartPieSolid, ChartScatter, Check, CheckCircle, CheckCircleSolid, CheckSolid, ChevronDown, ChevronFirst, ChevronLast, ChevronLeft, ChevronRight, ChevronUp, ChevronsDown, ChevronsDownUp, ChevronsLeft, ChevronsRight, ChevronsUp, ChevronsUpDown, Clipboard, ClipboardCheck, ClipboardList, Clock, ClockSolid, Close, CloseCircle, CloseCircleSolid, CloseSolid, Cloud, CodeBranch, CodeBranchPlus, CodeClose, CodeCloseSolid, CodeCommit, CodeFork, CodeMerge, CodeMergeSolid, CodeOpen, CodePullRequest, Coins, Compress, Condition, Contact, Contain, ContainCaseSensitive, Copy, CornerDownLeft, CornerDownRight, CornerLeftDown, CornerLeftUp, CornerRightDown, CornerRightUp, CornerUpLeft, CornerUpRight, CreditCard, Crosshair, Crown, Cube, Currency, Dashboard, Database, Desktop, DiscordSolid, Divide, Dollar, Download, DownloadCloud, Edit, Empty, Envelope, Equal, EqualSlash, Euro, Exclamation, ExclamationSolid, ExclamationTriangle, ExclamationTriangleSolid, Expand, ExternalLink, Eye, EyeSlash, File, FileCheck, FileCode, FileExport, FileImport, FileMinus, FilePlus, FileSpreadsheet, FileText, Files, Filter, Flag, Folder, FolderOpen, Font, FontCase, FormInput, Forward, Gauge, Gem, Gift, Github, Glasses, Globe, GreaterThan, GreaterThanEqual, Grid, GripHorizontal, GripVertical, Hammer, Hash, Heart, HeartSolid, Highlighter, Home, HomeSolid, ICursor, Image, InBetween, Info, InfoCircle, InfoCircleSolid, InfoSolid, Integrations, IntegrationsSolid, Key, Laptop, Layers, LessThan, LessThanEqual, Library, Lightbulb, Link, LinkSlash, List, ListSolid, Loader, Location, LocationFixed, Lock, LockSolid, LogIn, LogOut, LogOutSolid, Map, MapPin, Maximise, Megaphone, Menu, Merge, Message, MessageSolid, Microchip, Minimise, Minus, MinusCircle, MinusCircleSolid, MinusSolid, MoreHorizontal, MoreVertical, Move, MoveDiagonal1, MoveDiagonal2, MoveHorizontal, MoveVertical, Mute, NetworkWired, News, NotContain, NotContainCaseSensitive, NotEmpty, NotOneOf, OneOf, Palette, PanelClose, PanelOpen, Paperclip, Pen, Pencil, Percent, Phone, Play, PlaySolid, Plug, Plus, PlusCircle, PlusCircleSolid, PlusSolid, Power, Question, QuestionCircle, QuestionCircleSolid, QuestionSolid, React, Refresh, Repeat, RocketLaunch, RotateLeft, RotateRight, Save, Scissors, ScreenShare, Search, Send, Settings, SettingsSolid, Share, Shield, ShieldAlert, ShieldCheck, ShieldClose, ShieldKey, ShieldSlash, ShoppingBag, ShoppingBasket, ShoppingCart, ShoppingCartFast, ShoppingCartSolid, Signal, Signature, SignatureLock, Skull, Slash, Slider, Sort19, Sort91, SortAZ, SortAsc, SortDesc, SortZA, Split, Star, StarSolid, Stopwatch, Store, SwitchOff, SwitchOffSolid, SwitchOn, SwitchOnSolid, Table, Tablet, Tag, Tally, TallySolid, Target, Test, Text, TextSize, ThumbsDown, ThumbsUp, Ticket, Timeline, Trash, TrendingDown, TrendingUp, Unlock, Upload, UploadCloud, User, UserCheck, UserMinus, UserPlus, UserX, Video, Wallet, Wand, Webhook, Wifi, WifiOff, Workflow, WorkflowSolid, Wrench, ZoomIn, ZoomOut };